export const ProjectManagement = () => (
	<svg width={40} height={40} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M33.275 18.1208H12.9792V28.0375H33.275V18.1208Z" fill="#BF63F3" />
		<path d="M26.9667 11.9624H6.67084V21.8791H26.9667V11.9624Z" fill="#FCA700" />
		<path d="M26.9667 18.1208H12.9792V21.8792H26.9667V18.1208Z" fill="#AE2A19" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32.0125 21.7042L27.6417 26.075L25.3834 23.7542L26.3584 22.8083L27.6584 24.1417L31.0542 20.7458L32.0167 21.7083L32.0125 21.7042Z"
			fill="white"
		/>
	</svg>
);

export const ProjectManagementHovered = () => (
	<svg width={40} height={40} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M33.275 18.1208H12.9792V28.0375H33.275V18.1208Z" fill="#BF63F3" />
		<path d="M26.9667 11.9624H6.67084V21.8791H26.9667V11.9624Z" fill="#FCA700" />
		<path d="M26.9667 18.1208H12.9792V21.8792H26.9667V18.1208Z" fill="#AE2A19" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32.0125 21.7042L27.6417 26.075L25.3834 23.7542L26.3584 22.8083L27.6584 24.1417L31.0542 20.7458L32.0167 21.7083L32.0125 21.7042Z"
			fill="white"
		/>
		<path
			d="M18.197 8.96999C17.9677 8.92297 17.8414 8.6968 17.5653 8.83114C16.7371 9.23641 15.6773 10.562 15.3428 11.1128C14.5403 11.5225 13.1085 13.3541 12.5353 14.3012C12.1914 14.9125 11.2252 16.4977 11.2252 16.4977L11.1058 16.4888C11.1058 16.4888 9.24824 14.1019 8.30306 13.6138C8.13461 13.5601 7.94979 13.6116 7.78836 13.8512C7.7018 13.9362 8.3405 14.693 8.49023 14.702C8.63528 14.6258 9.30205 15.6021 9.70913 16.0947C10.9842 17.6441 11.2322 17.7784 11.8334 17.2814C12.8348 16.4529 17.1606 10.5396 18.197 8.96775V8.96999Z"
			fill="#101214"
		/>
	</svg>
);
